import React, { useId, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUpRight, FiSearch } from 'react-icons/fi';
import catalogue from './voicesServicesReference.json';
import './voices-services.css';

export default function VoicesServices() {
  const id = useId();
  const [category, setCategory] = useState('All');
  const [query, setQuery] = useState('');
  const services = catalogue.services.filter(service =>
    (category === 'All' || service.category === category) &&
    `${service.name} ${service.category} ${service.headline}`.toLowerCase().includes(query.toLowerCase())
  );

  return <main className="v-services-reference" data-voices-theme="dark" aria-labelledby={`${id}-title`}>
    <section className="v-services-intro">
      <nav className="v-services-breadcrumb" aria-label="Breadcrumb"><Link to="/">Home</Link><span aria-hidden="true">/</span><span aria-current="page">Services</span></nav>
      <p className="v-services-eyebrow">OUR EXPERTISE</p>
      <h1 id={`${id}-title`}>The right expertise.<br /><em>Working together.</em></h1>
      <p className="v-services-description">Find the service you need. Explore how it connects to the rest of your business.</p>
    </section>
    <section className="v-services-directory" aria-label="Services directory">
      <div className="v-services-controls">
        <label className="v-services-select">Explore by area
          <select aria-label="Filter services by area" aria-controls={`${id}-list`} value={category} onChange={event => setCategory(event.target.value)}>
            {catalogue.categories.map(value => <option key={value} value={value}>{value === 'All' ? 'All services' : value}</option>)}
          </select>
        </label>
        <label className="v-services-search">
          <FiSearch aria-hidden="true" />
          <input type="search" aria-label="Search services" aria-controls={`${id}-list`} placeholder="Find a service or platform" value={query} onChange={event => setQuery(event.target.value)} />
        </label>
      </div>
      <p className="v-services-count" role="status" aria-live="polite">{services.length} SERVICES / {category.toUpperCase()}</p>
      <div className="v-services-list" id={`${id}-list`}>
        {services.map(service => <Link key={service.path} to={service.path} aria-label={service.name}>
          <div><small>{service.category}</small><h3>{service.name}</h3></div>
          <FiArrowUpRight aria-hidden="true" />
        </Link>)}
        {!services.length && <p className="v-services-empty">No matching service. Try a different phrase or choose All.</p>}
      </div>
    </section>
  </main>;
}
